<template>
    <Container v-if="showSection">
        <SectionHeader :title="title" :description="description" />
        <InfiniteScroll :once="true" @isvisible="loadData" v-if="loading">
            <div class="list">
                <div class="item" v-for="i in 6" :key="i">
                    <div class="thumbnail preLoaderPlaceholder"></div>
                    <div class="title preLoaderPlaceholder"></div>
                </div>
            </div>
        </InfiniteScroll>
        <div class="list" v-else>
            <Item v-for="item in data" :key="item.id" :data="item" />
        </div>
    </Container>
</template>
<script>
import Item from "./item.vue";
export default {
    props: {
        title: {
            type: String,
            default: "WisdomShots",
        },
        description: {
            type: String,
            default:
                "I produce short videos with the intention of helping improve your daily life through relatable stories, fresh ideas, and useful resources. I hope that some of the lessons from my videos will positively impact your life in some way.",
        },
        excluedIds: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        Item,
    },
    data() {
        return {
            data: [],
            loading: true,
            showSection: true,
        };
    },
    methods: {
        loadData() {
            const exclude = this.excluedIds.join(",");

            axios
                .get(this.$route("home.vlogs.api"), {
                    params: {
                        exclude,
                    },
                })
                .then(({ data }) => {
                    this.data = data.data || [];
                    setTimeout(() => {
                        this.loading = false;
                        this.showSection = this.data.length > 0;
                    }, 100);
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 1.4rem;

    .item {
        .thumbnail.preLoaderPlaceholder {
            height: 200px;
            margin: 0;
            border-radius: var(--border-radius);
            box-shadow: var(--box-shadow);
        }
        .title.preLoaderPlaceholder {
            margin: 0.6rem;
            margin-bottom: 1.2rem;
        }
    }
}
</style>
